module.exports = __webpack_public_path__ + "img/food.49a89875.svg";